import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardChipsProps extends WithClassName {
  children?: React.ReactNode
}

export const ProjectCardChips = React.memo(
  ({ children, className }: ProjectCardChipsProps) => (
    <div className={classNames("project-card__chips", className)}>
      {children}
    </div>
  )
)
